import { ApiService } from '../model/Api.model';
import { AxiosInstance } from 'axios';

enum CompanyNegociationServiceEnum {
	getAllSocialReason = '/list-social-reason'
}

export default class CompanyNegociationService extends ApiService {
	constructor(restClient: AxiosInstance) {
		super(restClient, '/company');
	}

	public getAllSocialReason = async () => await this.GET(CompanyNegociationServiceEnum.getAllSocialReason);

}



// WEBPACK FOOTER //
// ./src/services/api/CompanyNegociation.service.ts